// Configuration FontAwesome pour éviter de charger toute la bibliothèque
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser,
  faEdit,
  faDollarSign,  
  faHistory,
  faUserPlus,
  faFileImport,
  faUsers,
  faMoneyBillWave,
  faClipboardList,
  faSignOutAlt,
  faCog,
  faEye,
  faEyeSlash,
  faCheckCircle,
  faBan
} from '@fortawesome/free-solid-svg-icons';

// Ajouter seulement les icônes utilisées à la bibliothèque
library.add(
  faUser,
  faEdit,
  faDollarSign,
  faHistory,
  faUserPlus,
  faFileImport,
  faUsers,
  faMoneyBillWave,
  faClipboardList,
  faSignOutAlt,
  faCog,
  faEye,
  faEyeSlash,
  faCheckCircle,
  faBan
);